import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/manage/page', Object.assign({}, options, {
    params
  }));
  export const getManageDetail = (params, options) =>
    request.get('/api/v4ward/car/manage/detail', Object.assign({}, options, {
      params
    }));

export const getDetail = (params, options) =>
  request.get('/api/park/vehicle/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/park/vehicle/remove/v2', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/vehicle/save/v2', params, options);

export const addCarMonth = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/save/v2', params, options);

export const addCarMonthNew = (params, options) =>
  request.post('/api/v4ward/monthcar/v1/add/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/car/manage/update', params, options);

export const plateNumberChange = (params, options) =>
  request.post('/api/v4ward/car/manage/plateNumberChange', params, options);

export const approve = (params, options) =>
  request.post('/api/v4ward/car/manage/approveCar', params, options);

export const syncVehicles = (params, options) =>
  request.post('/api/park/vehicle/sync/v2', qs.stringify(params), options);
export const getcarMonthLastEndTime = (params, options) =>
  request.get(
    '/api/v4ward/car/CarMonth/carMonthLastEndTime/v2',
    Object.assign({}, options, {
      params
    })
  );

export const saveCarCharge = (params, options) =>
  request.post('/api/v4ward/car/recharge/submit/v2', params, options);

export const carMonthRule = (params, options) =>
  request.get(
    '/api/v4ward/car/monthDiscountRule/carMonthRule/v2',
    Object.assign({}, options, {
      params
    })
  );
export const getPaySceneList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/car/recharge/getPayScene/v2",
    Object.assign({}, options, {
      params
    })
  );


export const getMonthCarFeeInFo = (params = {}, options = {}) =>
request.get(
  "/api/v4ward/car/manage/getMonthCarFeeInFo",
  Object.assign({}, options, {
    params
  })
);

export const queryCarCharge = (params, options) =>
  request.get('/api/v4ward/car/recharge/pay/query/v2', Object.assign({}, options, {
    params
  }));

export const getBuildingList = (params, options) =>
  request.get('/api/v4ward/car/property/getBuildingList', Object.assign({}, options, {
    params
  }));

export const getRoomList = (params, options) =>
  request.get('/api/v4ward/car/property/getRoomList', Object.assign({}, options, {
    params
  }));


  export const getCarRuleDiscountList = (params, options) =>
  request.get('/api/v4ward/carfeerulediscount/carRuleDiscountList', Object.assign({}, options, {
    params
  }));

  export const getManagefeedetailList = (params, options) =>
  request.get('/api/v4ward/car/managefeedetail/page', Object.assign({}, options, {
    params
  }));

  export const getCarParkingSpaceList = (params, options) =>
  request.get('/api/v4ward/car/parking/space/page', Object.assign({}, options, {
    params
  }));

  export const getCarRuleList = (params, options) =>
  request.get('/api/v4ward/carfeerule/carRuleList', Object.assign({}, options, {
    params
  }));

  // export const calculateMonthCarFeeInFo = (params, options) =>
  // request.get('/api/v4ward/car/manage/calculateMonthCarFeeInFo', Object.assign({}, options, {
  //   params
  // }));


export const addRegister = (params, options) => request.post('/api/v4ward/car/manage/register', params, options);


  export const calculateMonthCarFeeInFo = (params, options) =>
  request.post('/api/v4ward/car/manage/calculateMonthCarFeeInFo', params, options);
  // export const getCarRuleDiscountList = (params, options) =>
  // request.get('/api/v4ward/carfeerulediscount/carRuleDiscountList', Object.assign({}, options, {
  //   params
  // }));

  export const editPlus = (params, options) =>
  request.post('/api/v4ward/car/manage/editPlus', params, options);
  export const editNormal = (params, options) =>
  request.post('/api/v4ward/car/manage/update', params, options);

  export const carManageCheckPay = (params, options) =>
    request.post('/api/v4ward/car/manage/checkPay', params, options);

  export const carManagePay = (params, options) =>
  request.post('/api/v4ward/car/manage/pay', params, options);


  // export const carManagePayQuery = (params, options) =>
  // request.post('/api/v4ward/car/manage/pay/query', params, options);


  export const carManagePayQuery = (params, options) =>
  request.get('/api/v4ward/car/manage/pay/query', Object.assign({}, options, {
    params
  }));



  export const mainCarChangeOrRemoveCheck = (params, options) =>
  request.get('/api/v4ward/car/manage/mainCarChangeOrRemoveCheck', Object.assign({}, options, {
    params
  }));

  export const mainSecondChange = (params, options) =>
  request.post('/api/v4ward/car/manage/mainSecondChange',  qs.stringify(params), options);


  export const removeMainCar = (params, options) =>
  request.post('/api/v4ward/car/manage/remove',  qs.stringify(params), options);

  export const secondCarChangeCheck = (params, options) =>
  request.get('/api/v4ward/car/manage/secondCarChangeCheck', Object.assign({}, options, {
    params
  }));

  export const getCarRuleDiscountListNew = (params, options) =>
  request.get('/api/v4ward/carfeerulediscount/best/carRuleDiscountList', Object.assign({}, options, {
    params
  }));

  // /v4ward/car/manage/detail


  export const getCarManageStatusCount = (params, options) =>
  request.get('/api/v4ward/car/manage/status/count', Object.assign({}, options, {
    params
  }));

export const carManageRefund = (params, options) =>
  request.post('/api/v4ward/car/manage/refund', params, options);
